// Canonical @id values must match hubspot.com/products/* entities exactly so
// Google merges the pricing page Offers into the existing product entity.
const PRODUCT_SCHEMA_CONFIG = {
  CONTENT: {
    productId: 'https://www.hubspot.com/products/content#product'
  },
  MARKETING: {
    productId: 'https://www.hubspot.com/products/marketing#product'
  },
  SALES: {
    productId: 'https://www.hubspot.com/products/sales#product'
  },
  SERVICE: {
    productId: 'https://www.hubspot.com/products/service#product'
  },
  COMMERCE: {
    productId: 'https://www.hubspot.com/products/commerce#product'
  },
  DATA: {
    productId: 'https://www.hubspot.com/products/data#product'
  }
};
export function getProductSchemaConfig(productGroup) {
  return PRODUCT_SCHEMA_CONFIG[productGroup];
}